// Tiers visuales del chip de la tarjeta: neutral | coral | amber | product (sellado/grupo).
const CORAL = new Set([
  "rare", "rare holo", "promo", "epic",
  "super rare",
]);
const AMBER = new Set([
  "double rare", "ultra rare", "illustration rare", "special illustration rare", "hyper rare",
  "mega hyper rare", "shiny rare", "shiny ultra rare", "ace spec rare", "holo rare v", "holo rare vmax", "holo rare vstar",
  "legend", "overnumbered",
  "secret rare", "ultimate rare", "ghost rare", "starlight rare", "quarter century secret rare",
  "collector's rare", "collectors rare", "prismatic secret rare", "platinum secret rare",
]);

// Yu-Gi-Oh Overframe (arte que sale del marco): el API lo trae como Ultra/Starlight Rare, no como rareza propia.
export const OVERFRAME_RE = /^RA05-[A-Z]{2}1(4[1-9]|50)$/;
export const ygoNote = (v) => v?.yugioh_rarity_note || (OVERFRAME_RE.test(v?.yugioh_set_code || "") ? "Overframe" : "");
export const ygoRarityLabel = (v) => { const n = ygoNote(v); return n ? `${v.yugioh_rarity} · ${n}` : v.yugioh_rarity; };

// Carta holo por rareza (su versión normal ya es holo) → la variante "normal" se muestra como "Holo".
export const isHoloCard = (c) => {
  const r = String(c?.rarity || "").toLowerCase();
  const va = c?.variants_available || {};
  return c?.holo_card === true || (r.includes("holo") && !r.includes("reverse")) || (!!va.holo && !va.normal);
};

export const variantLabelFor = (variant, card) =>
  variant === "normal" ? (isHoloCard(card) ? "Holo" : "Normal") : (VARIANT_LABEL[variant] || variant);

export const VARIANT_LABEL = {
  normal: "Normal",
  reverse_holo: "Retroholográfica",
  price_pack: "Price Pack",
  patron: "Patrón",
  sealed: "Sellado",
  bundle: "Grupo",
  promo: "Promo",
  overnumbered: "Overnumbered",
  alt_art: "Alt-Art",
};
const VARIANT_TIER = { reverse_holo: "coral", price_pack: "coral", patron: "coral", promo: "coral", alt_art: "amber", overnumbered: "amber" };
export const VARIANT_TIER_OF = (variant) => VARIANT_TIER[variant] || "neutral";

export function rarityTier(rarity) {
  const r = String(rarity || "").trim().toLowerCase();
  if (AMBER.has(r) || /secret|ultra|ultimate|ghost|starlight|collector|quarter century/.test(r)) return "amber";
  if (CORAL.has(r)) return "coral";
  return "neutral";
}

export const TIER_CHIP = {
  neutral: "border-white/20 text-white bg-[#080808]",
  coral: "border-[rgba(255,68,56,.7)] text-[#ff8a80] bg-[#080808]",
  amber: "border-[#fbbf24] text-[#fbbf24] bg-[#080808]",
  product: "border-white text-[#080808] bg-white",
};
export const TIER_GLOW = {
  neutral: "",
  coral: "shadow-[0_10px_30px_-12px_rgba(255,68,56,.55)]",
  amber: "shadow-[0_10px_30px_-12px_rgba(251,191,36,.5)]",
  product: "",
};
